export default __webpack_public_path__ + "static/media/CoffeeMug1.7a24a43f.png";